import { render, staticRenderFns } from "./StaticViewHeading.vue?vue&type=template&id=be54ca22&scoped=true&"
import script from "./StaticViewHeading.vue?vue&type=script&lang=js&"
export * from "./StaticViewHeading.vue?vue&type=script&lang=js&"
import style0 from "./StaticViewHeading.vue?vue&type=style&index=0&id=be54ca22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be54ca22",
  null
  
)

export default component.exports